(() => {
  let modal;
  let modalImage;
  let counter;
  let previousButton;
  let nextButton;
  let activeLinks = [];
  let activeIndex = 0;
  let trigger;

  const showImage = (index) => {
    activeIndex = (index + activeLinks.length) % activeLinks.length;
    const link = activeLinks[activeIndex];
    const sourceImage = link.querySelector('.product-image');

    modalImage.src = link.href;
    modalImage.alt = sourceImage?.alt || '';
    counter.textContent = `${activeIndex + 1} / ${activeLinks.length}`;
    previousButton.hidden = activeLinks.length < 2;
    nextButton.hidden = activeLinks.length < 2;
  };

  const close = () => {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    modalImage.removeAttribute('src');
    document.documentElement.classList.remove('product-gallery-lightbox-open');
    trigger?.focus();
  };

  const createModal = () => {
    modal = document.createElement('div');
    modal.className = 'product-gallery-lightbox';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Galerie produit agrandie');
    modal.innerHTML = `
      <button class="product-gallery-lightbox__close" type="button" aria-label="Fermer la galerie">×</button>
      <button class="product-gallery-lightbox__nav product-gallery-lightbox__nav--prev" type="button" aria-label="Image précédente">‹</button>
      <figure class="product-gallery-lightbox__figure">
        <img class="product-gallery-lightbox__image" alt="">
        <figcaption class="product-gallery-lightbox__counter" aria-live="polite"></figcaption>
      </figure>
      <button class="product-gallery-lightbox__nav product-gallery-lightbox__nav--next" type="button" aria-label="Image suivante">›</button>
    `;

    modalImage = modal.querySelector('.product-gallery-lightbox__image');
    counter = modal.querySelector('.product-gallery-lightbox__counter');
    previousButton = modal.querySelector('.product-gallery-lightbox__nav--prev');
    nextButton = modal.querySelector('.product-gallery-lightbox__nav--next');

    modal.querySelector('.product-gallery-lightbox__close').addEventListener('click', close);
    previousButton.addEventListener('click', () => showImage(activeIndex - 1));
    nextButton.addEventListener('click', () => showImage(activeIndex + 1));
    modal.addEventListener('click', (event) => {
      if (event.target === modal) close();
    });
    document.addEventListener('keydown', (event) => {
      if (modal.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') showImage(activeIndex - 1);
      if (event.key === 'ArrowRight') showImage(activeIndex + 1);
    });

    document.body.appendChild(modal);
  };

  const handleGalleryClick = (event) => {
    const lightboxTrigger = event.target.closest('.cc-main-product .product-gallery-lightbox-trigger');
    const link = lightboxTrigger
      ? lightboxTrigger.closest('.media-viewer__item').querySelector('.js-zoom-link')
      : event.target.closest('.cc-main-product .js-zoom-link');
    if (!link) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const gallery = link.closest('media-gallery');
    activeLinks = [...gallery.querySelectorAll('.js-zoom-link')]
      .filter((item) => item.closest('.media-viewer__item')?.style.display !== 'none');
    trigger = lightboxTrigger || link;

    if (!modal) createModal();
    showImage(Math.max(activeLinks.indexOf(link), 0));
    modal.hidden = false;
    document.documentElement.classList.add('product-gallery-lightbox-open');
    modal.querySelector('.product-gallery-lightbox__close').focus();
  };

  document.querySelectorAll('.cc-main-product .js-zoom-link').forEach((link) => {
    link.addEventListener('click', handleGalleryClick, true);
  });
  document.addEventListener('click', handleGalleryClick, true);
  document.documentElement.dataset.productGalleryLightbox = 'ready';
})();
